// Namespace, Type, Values
Jelly.Actions.Cancel_Create_On_Submit = function(Parameters) {
	var Input_Alias = "Create_On_Submit";

	// Get current value if it exists
	var Value_Input = $(Jelly.Actions.Get_Input_From_Action_By_Alias({
		Namespace: Parameters["Namespace"], 
		Alias: Input_Alias
	}));

	// If it exists, slice out the passed in value, and save new value to DOM
	if (Value_Input.length) {

		// Translate JSON to Array
		var Current_Create_On_Submit_Value = JSON.parse(Value_Input.val());

		// Copy array to lol hash
		var Current_Create_On_Submit_Value_Hash = [];
		for (var i = 0; i < Current_Create_On_Submit_Value.length; i++) {
			Current_Create_On_Submit_Value_Hash[JSON.stringify(Current_Create_On_Submit_Value[i])] = i;
		}

		// Create value to remove
		var Remove_Value = {
			Type: Parameters["Type"],
			Data: Parameters["Values"]
		};

		// Get index of value to remove
		var Remove_Value_Index = -1;
		Remove_Value_Index = Current_Create_On_Submit_Value_Hash[JSON.stringify(Remove_Value)];
		
		// If found, remove from values
		if (Remove_Value_Index != -1) { 
			
			// Remove from values array
			Current_Create_On_Submit_Value.splice(Remove_Value_Index, 1);
			
			// Add updated value to DOM
			Jelly.Actions.Add_Hidden_Value({
				Namespace: Parameters["Namespace"],
				Input_Alias: Input_Alias,
				Value: JSON.stringify(Current_Create_On_Submit_Value)
			});
		}
	}
	
};